import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Utilities.types'

@Injectable({ providedIn: 'root' })
export class Utilities_convert_distance_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inputDistance: number, fromUom: number, toUom: number }): Promise<{ convertedDistance?: number, reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inputDistance)) {
      missingRequiredInParams.push('\'inputDistance\'');
    }
    if (isNil(inParams.fromUom)) {
      missingRequiredInParams.push('\'fromUom\'');
    }
    if (isNil(inParams.toUom)) {
      missingRequiredInParams.push('\'toUom\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/functions/convert_distance_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

